<member-risk-read-only></member-risk-read-only>
<div class="risk-member">
  <app-member-validation-v2 class="risk-member__member-validation-v2" [configuration]="memberValidationData"
    (onSubmit)="memberValidationSubmit($event, showSuccessToast)"
    (onCorrectMemberSelection)="showMemberValidationInputs($event)" [enabled]="isMemberValidationEnabled">
  </app-member-validation-v2>
  <app-member-dob-gen-v2 class="risk-member__member-dob-gen-v2" [configuration]="memberValidationData"
    [chaseId]="chaseId" [enabled]="isMemberDOBFormEnabled" [isMemberValidate]="isMemberValidate" (onChange)="handleChange($event)"></app-member-dob-gen-v2>
</div>